<template>
<chart-line :data="dataChart" :options="options" :width="1000" :height="300"></chart-line>
</template>

<script>
import ChartLine from '@/components/charts/Line'
import colors from 'vuetify/es5/util/colors'

export default {
  name: 'MeterPredictionChart',
  props: {
    training: {
      type: Array,
      required: true
    },
    validation: {
      type: Array,
      required: true
    },
    prediction: {
      type: Array,
      required: true
    }
  },
  components: {
    'chart-line': ChartLine
  },
  computed: {
    baseItem() {
      let now = new Date().getTime();
      let ago = now - 2 * 24 * 60 * 60 * 1000;
      return this.training.find(data => data.t >= ago);
    },
    trimedTraining() {
      let base = this.baseItem || {};
      return this.training
        .filter(data => data.t >= (base.t || 0))
        .map(data => {
          data.y -= (base.y || 0);
          return data;
        })
    },
    shiftedPrediction() {
      return this.prediction.map(data => {
        data.y -= (base.y || 0);
        return data;
      })
    },
    dataChart() {
      return {
        datasets: [{
          data: this.trimedTraining || null,
          borderWidth: 1.5,
          lineTension: 0,
          pointRadius: 0,
          borderColor: colors.blue.base,
          backgroundColor: colors.blue.base,
          fill: false,
          label: this.$t('prediction.training')
        }, {
          data: this.prediction || null,
          borderWidth: 1.5,
          lineTension: 0,
          pointRadius: 0,
          borderColor: colors.green.base,
          backgroundColor: colors.green.base,
          fill: false,
          label: this.$t('prediction.prediction')
        }]
      }
    },
    options() {
      let now = new Date().getTime();
      return {
        legend: {
          display: true
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              unit: 'day'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: function(value, index, values) {
                if (value < 10000)
                  return value;
                else
                  return (value / 1000).toFixed(0) + 'k'
              }
            },
            scaleLabel: {
              display: true,
              labelString: 'kWh'
            }
          }]
        },
        tooltips: {
          intersect: false,
          mode: 'nearest'
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: false
      };
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/juice/MeterPredictionChart.vue